import AbstractService from "./abstract.service"
import QrTransformer, { baseUri } from "@/transformers/qr.transformer"
import { buildQueryString } from "./utils"
class QrService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: QrTransformer })
  }

  getAll(filter) {
    return this.getCollection(`${this.baseUri}`, {
      queryString: buildQueryString(filter),
      needsAuth: true
    })
  }

  getCriteria(uuid) {
    return this.get(`${this.baseUri}/${uuid}/criteria`, {
      needsAuth: true,
      transformer: QrTransformer,
      transformerMethod: "fecthCriteria"
    })
  }

  getReport({ criteria, fromDate, toDate, format }) {
    return this.post(`/api/reports`, {
      needsAuth: true,
      responseType: "blob",
      payload: {
        criteria,
        fromDate,
        toDate,
        format
      }
    })
  }
}

const qrService = new QrService()
export default qrService
